import Vue from "vue";
import VueRouter from "vue-router";
// import { clearLoginInfo } from '@/utils'

// 防止路由菜单重复点击报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);
const _import = require('./import-' + process.env.NODE_ENV);
// 全局路由(无需嵌套上左右整体布局)
const globalRoutes = [
    { path: '/login', component: _import('login/login'), name: 'login', meta: { title: '登录', mod: 'login' } },
    { path: '/resetpwd', component: _import('resetpwd/resetpwd'), name: 'resetpwd', meta: { title: '忘记密码', mod: 'resetpwd' } },
    { path: '/register', component: _import('register/register'), name: 'register', meta: { title: '注册', mod: 'register' } },
    { path: '/updateUserInfo', component: _import('resetpwd/updateUserInfo'), name: 'updateUserInfo', meta: { title: '修改账户信息', mod: 'updateUserInfo' } },
    { path: '/userInfo', component: _import('accountMg/userInfo'), name: 'userInfo', meta: { title: '账号管理', mod: 'userInfo' } },
    { path: '/404', component: _import('common/404'), name: '404', meta: { title: '404未找到', mod: '404' } },

];
// 主入口路由(需嵌套上左右整体布局)
const mainRoutes = {
    path: '/',
    component: _import('main'),
    name: 'main',
    redirect: { name: 'home' },
    meta: { title: '整体布局' },
    children: [
        { path: '/home', component: _import('home/home'), name: 'home', meta: { title: '首页', mod: 'home' } },
        { path: '/goods-details', component: _import('home/goods-details'), name: 'goods-details', meta: { title: '商品详情', mod: 'goods-details' } },
        { path: '/inspection', component: _import('inspection/inspection'), name: 'inspection', meta: { title: '送检', mod: 'inspection' } },
        { path: '/order', component: _import('order/order'), name: 'order', meta: { title: '我的订单', mod: 'order' } },
        { path: '/order-details', component: _import('order/order-details'), name: 'order-details', meta: { title: '订单详情', mod: 'order-details' } },
        { path: '/enterprise', component: _import('enterprise/enterprise'), name: 'enterprise', meta: { title: '企业信息', mod: 'enterprise' } },
        { path: '/enterprise-details', component: _import('enterprise/enterprise-details'), name: 'enterprise-details', meta: { title: '企业详情信息', mod: 'enterprise-details' } },
        { path: '/cart', component: _import('cart/cart'), name: 'cart', meta: { title: '购物车', mod: 'cart' } },
        { path: '/message', component: _import('message/message'), name: 'message', meta: { title: '消息管理', mod: 'message' } },
        { path: '/questionInvestigation', component: _import('questionInvestigation/questionInvestigation'), name: 'questionInvestigation', meta: { title: '问卷调查', mod: 'questionInvestigation' } },
        { path: '/report', component: _import('report/report'), name: 'report', meta: { title: '报告查询', mod: 'report' } },
        { path: '/billingInforManage', component: _import('billingInforManage/billingInforManage'), name: 'billingInforManage', meta: { title: '开票信息管理', mod: 'billingInforManage' } },
        { path: '/resourceManage', component: _import('resourceMg/resourceList'), name: 'resourceManage', meta: { title: '资源管理', mod: 'resourceManage' } },
        { path: '/myReport', component: _import('report/myReport'), name: 'myReport', meta: { title: '我的报告', mod: 'myReport' } },
        { path: '/accountMg', component: _import('accountMg/index'), name: 'accountMg', meta: { title: '账号管理', mod: 'accountMg' } }
    ],
    beforeEnter(to, from, next) {
        // let token = Vue.cookie.get('X-Admin-Token');
        // if (!token || !/\S/.test(token)) {
        //     clearLoginInfo();
        //     next({ name: 'login' });
        // }
        next();
    }
};

const router = new VueRouter({
    mode: 'hash',
    scrollBehavior: () => ({ y: 0 }),
    routes: globalRoutes.concat(mainRoutes)
});

export default router;